module.exports = __webpack_public_path__ + "images/f3e7ff05c96330562cd2671b2eb0f0a4.svg";